import { useFocusEffect } from 'expo-router'
import { useCallback } from 'react'
import { useAppView } from '~/components/layout/AppViewContext'
import ContentBox from '~/components/layout/ContentBox'
import ScreenView from '~/components/layout/ScreenView'
import MarkdownContent from '~/components/MarkdownContent.web'
import { PolicyLinks } from '~/components/user/PolicyLinks'

export default function DataProcessingAgreement() {
  const { setBackgroundTheme } = useAppView()

  useFocusEffect(
    useCallback(() => {
      setBackgroundTheme('primary')
    }, [setBackgroundTheme])
  )

  return (
    <ScreenView>
      <ContentBox className="mx-auto w-full max-w-2xl" contentContainerClassName="gap-4 pt-4">
        <PolicyLinks className="px-6" linkClassName="px-4 py-1" />
        <MarkdownContent contentKey="dpa" />
      </ContentBox>
    </ScreenView>
  )
}
